import { authorizedFetch } from '../../utils/api';

const BASE = '/api/personalize/invest';

export const connectorApi = {
  getProviders() {
    return authorizedFetch(`${BASE}/connections/providers`);
  },

  getConnections() {
    return authorizedFetch(`${BASE}/connections`);
  },

  linkConnection(provider, body) {
    return authorizedFetch(`${BASE}/connections/${provider}/link`, {
      method: 'POST',
      body,
    });
  },

  registerConnection(provider, body) {
    return authorizedFetch(`${BASE}/connections/${provider}/register`, {
      method: 'POST',
      body,
    });
  },

  confirmConnection(provider, body) {
    return authorizedFetch(`${BASE}/connections/${provider}/confirm`, {
      method: 'POST',
      body,
    });
  },

  disconnect(provider) {
    return authorizedFetch(`${BASE}/connections/${provider}`, {
      method: 'DELETE',
    });
  },

  getCatalog(catalogType, provider) {
    return authorizedFetch(`${BASE}/catalog/${catalogType}?provider=${provider}`);
  },

  getConnectionDetail(provider) {
    return authorizedFetch(`${BASE}/connections/${provider}/detail`);
  },

  syncStatus(provider) {
    return authorizedFetch(`${BASE}/connections/${provider}/sync-status`, {
      method: 'POST',
    });
  },

  vdscInitEkyc(inputType = 'EKYC') {
    return authorizedFetch(`${BASE}/connections/VDSC/ekyc/init?inputType=${inputType}`, {
      method: 'POST',
    });
  },

  vdscSubmitOcr(sessionToken, frontCard, backCard) {
    const formData = new FormData();
    formData.append('sessionToken', sessionToken);
    formData.append('frontCard', frontCard);
    formData.append('backCard', backCard);
    return authorizedFetch(`${BASE}/connections/VDSC/ekyc/ocr`, {
      method: 'POST',
      body: formData,
    });
  },
};
